import { render, staticRenderFns } from "./PagoMasivoNominas.vue?vue&type=template&id=58c5e6cc&"
import script from "./PagoMasivoNominas.vue?vue&type=script&lang=js&"
export * from "./PagoMasivoNominas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports